import { useEffect, useRef, useState } from "react";
import { useInView, animate } from "framer-motion";
import { Reveal } from "./Reveal";

const Counter = ({ to, suffix = "", pad = false }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [val, setVal] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, to, {
      duration: 1.8,
      ease: [0.16, 1, 0.3, 1],
      onUpdate: (v) => setVal(Math.round(v)),
    });
    return () => controls.stop();
  }, [inView, to]);

  const shown = pad ? String(val).padStart(2, "0") : String(val);
  return (
    <span ref={ref} data-testid={`counter-${to}`}>
      {shown}
      {suffix}
    </span>
  );
};

const stats = [
  { value: "2019", label: "Established" },
  { to: 5, suffix: "+", label: "Years Active" },
  { to: 3, pad: true, label: "Engineering Disciplines" },
  { to: 100, suffix: "%", label: "On-Time Execution" },
  { to: 2, pad: true, label: "States & Growing" },
];

export const Stats = () => (
  <section className="border-y border-white/10 bg-[#14171D]" data-testid="stats-strip">
    <div className="mx-auto grid max-w-7xl grid-cols-2 divide-x divide-white/10 sm:grid-cols-3 lg:grid-cols-5">
      {stats.map((s, i) => (
        <Reveal key={s.label} delay={i * 0.08} className="px-6 py-10 text-center">
          <p className="font-display text-4xl font-black tracking-tight text-[#FFFFFF] sm:text-5xl">
            {s.to !== undefined ? <Counter to={s.to} suffix={s.suffix || ""} pad={s.pad} /> : s.value}
          </p>
          <p className="mt-2 font-mono text-[11px] uppercase tracking-[0.25em] text-[#9CA3AF]">{s.label}</p>
        </Reveal>
      ))}
    </div>
  </section>
);
